import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

import { getViewPermission } from "../../getViewPermission";

const FeatureFlagsDetailsForNro = lazy(() =>
  import("@scenes/FeatureFlags/FeatureFlagsDetails/FeatureFlagsDetailsForNro").then((module) => ({
    default: module.FeatureFlagsDetailsForNro,
  }))
);

export const featureFlagsDetailsNRO: NavigationRoutingObject = {
  Component: FeatureFlagsDetailsForNro,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("feature-flags-sidebar-pill-menu-option", "Feature Flags"),
  pageNameForTracking: () => "Feature Flags",
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "feature-flags-sidebar-pill-menu-option-description",
      "Remotely turn native functionality on or off in your app for a selection of users"
    ),
  featureLimitationKeys: ["can_only_view_landing_page_feature_flags"],
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return getViewPermission(featureOn, hasPermission);
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/feature_flags/:appGroupId",
};
